/**
 * OverlayOddsBox - Right-side odds panel with themed broadcast style
 * Colors adapt to Sommertravet mode via CSS variables
 */
import { TravparkLogo } from './TravparkLogo';

export function OverlayOddsBox({
  oddsVisible, showOdds, sortedHorses, gameType, legNumber,
  trackName, raceDistance, startMethod, startTime, flashingHorses, colors, renderDistArrow, sommertravetMode
}) {
  if (!oddsVisible) return null;

  return (
    <div 
      className={`overlay-box ${showOdds ? 'broadcast-slide-right' : 'broadcast-slide-right-out'}`}
      data-testid="overlay-box"
      style={{
        position: 'absolute', right: '90px',
        top: 'unset',
        bottom: '82px',
        width: '20%',
        height: 'fit-content',
        display: 'flex', flexDirection: 'column',
        borderRadius: '10px',
        backgroundColor: 'var(--theme-panel-bg)',
        overflow: 'hidden', zIndex: 1,
        border: '2px solid var(--theme-panel-border)',
        boxShadow: `0 0 30px rgba(var(--theme-accent-rgb), 0.15), 0 15px 45px rgba(0,0,0,0.5)`,
        isolation: 'isolate',
      }}
    >
      {/* Header */}
      <div style={{
        background: `linear-gradient(135deg, var(--theme-header-gradient) 0%, transparent 100%)`,
        borderBottom: '2px solid var(--theme-panel-border)',
        color: '#FFFFFF',
        padding: '8px 11px', display: 'flex', alignItems: 'center', gap: '8px',
        flexShrink: 0,
      }}>
        <TravparkLogo height={52} sommertravetMode={sommertravetMode} />
        <div style={{ flex: 1, textAlign: 'left' }}>
          <div style={{ fontFamily: "'Barlow Condensed', sans-serif", fontSize: '1.44rem', fontWeight: 700, letterSpacing: '0.08em', textTransform: 'uppercase', lineHeight: 1, color: 'var(--theme-accent)' }}>
            {gameType}-{legNumber}
          </div>
          <div style={{ fontFamily: "'Inter', sans-serif", fontSize: '0.8rem', color: 'rgba(255,255,255,0.6)', marginTop: '2px', textTransform: 'uppercase', letterSpacing: '0.1em' }}>
            {trackName} {raceDistance > 0 ? `• ${raceDistance}m` : ''} {startMethod && `• ${startMethod}`}
            {startTime && (() => {
              try { return ` • Kl. ${new Date(startTime).toLocaleTimeString('nb-NO', { hour: '2-digit', minute: '2-digit' })}`; }
              catch { return ''; }
            })()}
          </div>
        </div>
      </div>

      {/* Horse rows */}
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        {sortedHorses.slice(0, 6).map((horse, index) => (
          <div
            key={horse.number}
            className={`broadcast-row ${flashingHorses.has(horse.number) ? 'flash-update' : ''}`}
            style={{
              display: 'flex', alignItems: 'center', padding: '8px 11px',
              borderBottom: index < 5 ? '1px solid var(--theme-panel-border-faint)' : 'none',
              backgroundColor: index % 2 === 0 ? 'rgba(255,255,255,0.03)' : 'transparent',
            }}
          >
            <div style={{
              width: '35px', height: '35px', backgroundColor: 'var(--theme-accent)', color: 'var(--theme-accent-dark)',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              fontFamily: "'JetBrains Mono', monospace", fontWeight: 700, fontSize: '1.12rem',
              borderRadius: '5px', flexShrink: 0,
            }}>
              {horse.number}
            </div>
            <div style={{ flex: 1, marginLeft: '10px', overflow: 'hidden' }}>
              <div style={{
                fontFamily: "'Inter', sans-serif", fontWeight: 600, fontSize: '1.12rem', color: '#FFFFFF',
                whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', lineHeight: 1.2
              }}>
                {horse.name}
              </div>
              <div style={{ fontFamily: "'Inter', sans-serif", fontSize: '0.88rem', color: 'rgba(255,255,255,0.5)', lineHeight: 1.2 }}>
                {horse.driver}
              </div>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', marginRight: '10px', minWidth: '56px' }}>
              <div style={{ fontFamily: "'JetBrains Mono', monospace", fontSize: '0.96rem', color: 'var(--theme-accent)', fontWeight: 700, marginBottom: '2px' }}>
                {horse.distribution.toFixed(1)}%{renderDistArrow(horse.number)}
              </div>
              <div style={{ width: '48px', height: '5px', backgroundColor: `rgba(var(--theme-accent-rgb), 0.2)`, borderRadius: '3px', overflow: 'hidden' }}>
                <div style={{ height: '100%', width: `${Math.min(horse.distribution * 2, 100)}%`, backgroundColor: 'var(--theme-accent)', borderRadius: '3px' }} />
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Footer */}
      <div style={{
        padding: '6px 13px', borderTop: '2px solid var(--theme-panel-border)',
        background: `linear-gradient(135deg, var(--theme-header-gradient) 0%, transparent 100%)`,
        flexShrink: 0,
        display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px'
      }}>
        <div style={{
          fontFamily: "'JetBrains Mono', monospace", fontSize: '0.8rem', color: 'var(--theme-accent)',
          textTransform: 'uppercase', letterSpacing: '0.1em', fontWeight: 600
        }}>
          Direkteodds
        </div>
      </div>
    </div>
  );
}
